/* global $ */

import 'modernizr'; // eslint-disable-line
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import '../vendor/bootstrap';

import tracking from '../modules/tracking';
import header from '../modules/header';
import navigation from '../modules/navigation';
import navigationCart from '../modules/navigationCart';
import search from '../modules/search';
import toTop from '../modules/toTop';
import videoOverlay from '../modules/videoOverlay';
import slider from '../modules/slider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import datepicker from '../modules/datepicker';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import mediaRow from '../modules/mediaRow';
import controlledInput from '../modules/controlledInput';
import videoElement from '../modules/videoElement';
import searchComplete from '../modules/searchComplete';
import inViewport from '../helpers/inViewport';
import productSubmit from '../modules/productSubmit';
import relatedProductSubmit from '../modules/relatedProductSubmit';
import '../modules/gaTracking';
import product from '../ecommerce/product';
import productSlider from '../ecommerce/productSlider';
import filter from '../ecommerce/filter/filter';
import discount from '../ecommerce/discount';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  header.initialize();
  navigation.initialize();
  navigationCart.initialize();
  search.initialize();
  toTop.initialize();
  videoOverlay.initialize();
  slider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  datepicker.initialize();
  embedWrap();
  whatsapp.initialize();
  alert.initialize();
  mediaRow.initialize();
  controlledInput.initialize();
  videoElement.initialize();
  product.initialize();
  productSlider.initialize();
  filter.initialize();
  discount.initialize();
  searchComplete.initialize();
  productSubmit.initialize();
  relatedProductSubmit.initialize();
  // gaTracking();

  $('[data-toggle="tooltip"]').tooltip({
    trigger: 'click hover focus',
  });

  $('[data-toggle="popover"]').popover({
    trigger: 'click hover focus',
  });

  porta({
    messages: nl,

    onError: (formElement) => {
      const firstError = formElement.querySelector('.porta-error');

      if (!inViewport(firstError)) {
        const yOffset = -85;
        const offset = firstError.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: offset });
      }
    },
  });
};

export default general;
